<nav class="navbar navbar-dark">
    <div class="container">
        <span class="navbar-brand mb-0">Error 404</span>
        <ul class="navbar-nav ml-auto">
            <li class="nav-item">
                <button routerLink="" class="btn btn-primary btn-header">Zurück</button>
            </li>
        </ul>
    </div>
</nav>

<div class="container">
    <p>Seite nicht gefunden.</p>
    <button routerLink="" class="btn btn-primary btn-back">Zurück zum Kalender</button>
</div>